export const ALL_CATEGORIES_ID = 'ALL_CATEGORIES_ID';
export const ALL_SHOPS_ID = 'ALL_SHOPS_ID';
export const STORAGE_KEY_REMOVING_DELAY = 1000;
export const SCROLL_GAP = 50;
export const SCROLL_STEP = 600;
export const SCROLL_THRESHOLD = 10;
